module.exports = __webpack_public_path__ + "media/images/cnrs-logo-7e36d50991157fbe7f2bf141f4739192.png";